import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [
        // 専門家
        "specialist/auth/init/fulfilled",

        // 運営会社
        "admin/auth/init/fulfilled",
        "admin/data/specialist/fulfilled",
        "admin/data/notification/fulfilled",
        "admin/data/question/fulfilled",
        "admin/data/help/fulfilled",

        // マスター
        "master/prefectures/fulfilled",
        "master/businesses/fulfilled",
        "master/contacts/fulfilled",
        "master/categories/fulfilled",
      ],
    },
  }),
});

export type AppDispatch = typeof store.dispatch;

export default store;
